import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IconClockFilled } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import styles from './PendingView.module.css';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

export const PendingView = () => {
    return (
        <MainSectionWrapper className={styles.wrapper}>
            <div className={styles.card}>
                <div className={styles.iconContainer}>
                    <IconClockFilled className={styles.titleIcon} />
                </div>

                <div className={styles.title}>
                    <FormattedMessage
                        id="_.pending_view.title"
                        defaultMessage="Thanks! We're reviewing your application"
                    />
                </div>

                <div className={styles.bodyText}>
                    <FormattedMessage
                        id="_.pending_view.description"
                        defaultMessage="We'll aim to email you with a decision within 24 hours- we’re receiving more applications than usual at the moment, so please bear with us if we take a little longer."
                    />
                    {getCountry() === 'DE' && (
                        <span>
                            &nbsp;
                            <FormattedMessage
                                id="_.pending_view.contact"
                                defaultMessage="Contact us on {phoneNumber} if your application is urgent {email}"
                                values={{
                                    phoneNumber: (
                                        <a
                                            href="tel:069 9432 3020"
                                            className={styles.phoneNumber}
                                        >
                                            <FormattedMessage
                                                id="_.pending_view.phoneNumber"
                                                defaultMessage="+44-020-3778-0105"
                                            />
                                        </a>
                                    ),
                                    email: (
                                        <a
                                            href="mailto:support@iwoca.de"
                                            className={styles.phoneNumber}
                                        >
                                            <FormattedMessage
                                                id="_.pending_view.email"
                                                defaultMessage="support@iwoca.co.uk"
                                            />
                                        </a>
                                    )
                                }}
                            />
                        </span>
                    )}
                </div>
            </div>
        </MainSectionWrapper>
    );
};
